import React, { Component, Fragment } from "react";
import styles from "./Preview.css";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import {Button} from "@react-spectrum/button";

import Gallery from "./ProductPreviewGallery";
import {getUserProductPreview, getUserProductPreviewForAdmin} from "../../actions/products";
import { URL_PARAMS } from "../../utils/constants/URL_Addresses";
import {LICENSE_TYPE_VALUE, LICENSE_TYPE_NAME, PAGEBUILDER_OPTIONS, PRICING_TYPE} from "../../utils/constants/AppConstants";
import { BUILD_KEY_VALUE } from "../../utils/helpers/utilityHelpers";
import { formatCompatibilityName } from "../../utils/helpers/versionCompatibilityHelpers";
import FaSpinner from "react-icons/lib/fa/spinner";
import stripXss from "../../utils/helpers/stripXSS";
import assurance_program_img from "../../assets/images/assurance-program-badge.svg";

export class PreviewPage extends Component {
    constructor(props) {
        super(props);
        this.state = { compatibility: "ECE", loading: true, selectedTab:"overview", addInstallService: false, addSupportService: false, supportServicePrice: 0 };
    }

    componentDidMount() {
        let asAdmin = this.props.location.search;
        if (asAdmin === URL_PARAMS.AS_ADMIN) {
            this.props.getUserProductPreviewForAdmin(
                this.props.match.params.submissionId
            );
        } else {
            this.props.getUserProductPreview(
                this.props.match.params.submissionId
            );
        }
    }

    static getDerivedStateFromProps(nextProps, prevState) {
        if (
            nextProps.hasOwnProperty("previewProduct") &&
            Object.keys(nextProps.previewProduct).length &&
            nextProps.previewProduct !== prevState.previewProduct
        ) {
            return { loading: false };
        } else return null;
    }

    handleCompatibilityChange = e => {
        this.setState({ compatibility       : e.target.value });
        this.setState({ addInstallService   : false});
        this.setState({ addSupportService   : false});
        this.setState({ supportServicePrice : 0});
    };

    getLicenseFullName = license => {
        const licenseList = BUILD_KEY_VALUE(
            LICENSE_TYPE_VALUE,
            LICENSE_TYPE_NAME
        );
        let obj = licenseList.find(obj => obj.value === license);
        return obj ? obj.key : "";
    };

    getFormattedCategories = categories => {
        let newArr = [];
        for (let i = 0; i < categories.length; i++) {
            let tmp = categories[i].split("//");
            if (i === 0) {
                //Extracting Main category
                newArr.push(tmp[1]);
            }
            if (tmp[2]) {
                //Extracting Sub category
                newArr.push(tmp[2]);
            }
        }
        return newArr;
    };

    getFormattedBrowsers = browsers => {
        return browsers.join("\r\n");
    };

    inspectUrl = url => {
        return url.toLowerCase().startsWith("http") ? url : `http://${url}`;
    };

    activateTab = e => {
        this.setState({ selectedTab : e.target.id });
    };

    updateInstallation = box => {
        this.setState({ addInstallService : box.target.checked});
    };

    setSupportCost = e => {
        this.setState({ supportServicePrice : parseInt(e.target.value, 10)});
    };

    render() {
        const getTabClass = (tabName)=> (this.state.selectedTab === tabName) ? "box-link-tabs active" : "box-link-tabs";
        const _showPreview = () => {
            const {submission_id, name, platform, media_artifacts, long_description,
                release_notes, version_compatibility, support_tiers, prices, pricing_model, user_profile,
                external_services, version, stability, modified_at, categories,
                documentation_artifacts, license_type, custom_license_url,
                assurance_workflow,
                custom_license_name, technical_options, browsers} = this.props.previewProduct;
            const is_page_builder = (technical_options.page_builder_new_content_type || technical_options.page_builder_extends_content_type || technical_options.page_builder_used_for_content_creation);
            const showAssuranceBadge = (assurance_workflow === 'pass');
            if (typeof document !== 'undefined') {
                document.title = name;
            }
            if (submission_id) {
                return (
                    <div className="page-main" style={styles}>
                        <div className="row p-30">
                            <div className="column-66">
                                <div className="product-details-row">
                                    <div className="page-title-wrapper product">
                                        <div className="ico-product">
                                            <span className="product-image-container"> 
                                                <span className="product-image-wrapper">
                                                    <img className="product-image-photo" src={media_artifacts.icon_image.url} />
                                                </span>
                                            </span>
                                        </div>
                                        <div className="box-ov-title">
                                            <h1 className="page-title">
                                                <span class="base" data-ui-id="page-title-wrapper" itemProp="name"> {name} </span>
                                            </h1>
                                            <div className="by-company">
                                                <div class="case-left-name">
                                                    by {user_profile && (
                                                            <a href={user_profile.sellers_profile_url} target="_blank">
                                                                {user_profile.is_company && user_profile.company_profile.name ? user_profile.company_profile.name : user_profile.vendor_name}
                                                            </a>
                                                        )}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    {showAssuranceBadge &&
                                        <div className="assurance_badge_container">
                                            <a href = "https://developer.adobe.com/commerce/marketplace/guides/sellers/assurance/" target="_blank">
                                                <img className="assurance_badge_icon" src={assurance_program_img} alt="Assurance Program badge" />
                                            </a>
                                        </div>
                                    }
                                    <div className="box-right-reviews">
                                        <div data-bv-show="inline_rating" data-bv-ready="true">
                                            <div>
                                                <div className="bv_main_container" itemProp="aggregateRating" itemscope itemType="https://schema.org/AggregateRating">
                                                    <div className="bv_stars_component_container" aria-hidden="true">
                                                        <div className="bv_stars_button_container">
                                                            <span className="bv_stars_svg_no_wrap" aria-hidden="true">
                                                                <div class="review-star"></div>
                                                                <div class="review-star"></div>
                                                                <div class="review-star"></div>
                                                                <div class="review-star"></div>
                                                                <div class="review-star"></div>
                                                            </span>
                                                        </div>  
                                                    </div>
                                                    <div className="bv_averageRating_component_container" aria-hidden="true">
                                                        <div className="bv_text">&nbsp; 0.0 &nbsp;</div>
                                                    </div>
                                                    <div className="bv_numReviews_component_container" aria-hidden="true">
                                                        <div className="bv_text"> &#40;0&#41; </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {media_artifacts && media_artifacts.gallery_images && (
                                    <Gallery media_artifacts={media_artifacts}/>
                                )}
                            </div>

                            <div className="column-34">
                                <div className="product-info-main">
                                    <div className="box-in">
                                        <div className="box-tocart">
                                            {version_compatibility && (
                                                <div id="edition">
                                                    <label className="label" htmlFor="editions">
                                                        <span>Edition</span>
                                                    </label>
                                                    <select name="editions" id="editions" onChange={this.handleCompatibilityChange} value={this.state.compatibility}>
                                                        {version_compatibility.map(
                                                            (item, index) => {
                                                                return (
                                                                    <option key={index} value={item.edition} selected="">
                                                                        {formatCompatibilityName(item.edition)}
                                                                    </option>
                                                                );
                                                            }
                                                        )}
                                                    </select>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                    <div className="box-in">
                                        <div className="box-tocart">
                                            {version_compatibility && (
                                                <div id="extension_compatibility">
                                                    <label className="label" htmlFor="compatible_with">
                                                        <span>Your store version</span>
                                                    </label>
                                                    <select name="compatible_with" id="compatible_with">
                                                        <option value="0">Choose Adobe Commerce Store version</option>
                                                        {version_compatibility.map(
                                                            (item, index) => {
                                                                if (this.state.compatibility === item.edition) {
                                                                    return item.versions.map(
                                                                        version => {
                                                                            return (
                                                                                <option key={index} value={version} selected="">
                                                                                    {version} &#40;Open Source &#40;CE&#41;&#41;
                                                                                </option>
                                                                            );
                                                                        }
                                                                    );
                                                                }
                                                            }
                                                        )}
                                                    </select>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                    <div className="box-in">
                                        <div className="box-tocart">
                                            {support_tiers.every( tier => {
                                                    if (this.state.compatibility === tier.edition) {
                                                        this.state.addSupportService = true;
                                                        return;
                                                    }
                                                }
                                            )}
                                            {this.state.addSupportService && (
                                                <div id="extension_support">
                                                    <label className="label" htmlFor="compatible_with">
                                                        <span>Support</span>
                                                    </label>
                                                    <select name="compatible_with" id="compatible_with" onChange={this.setSupportCost}>
                                                        <option value="0">Choose an option</option>
                                                        {support_tiers.map(
                                                            (tier, index) => {
                                                                if (this.state.compatibility === tier.edition) {
                                                                    return (
                                                                        <option key={index} value={tier.prices.map ((prices) => {return prices.price}) } selected="">
                                                                            {tier.monthly_period} Month Service Agreement- ${tier.prices.map ((prices) => {return prices.price}) }
                                                                        </option>
                                                                    );
                                                                }
                                                            }
                                                        )}
                                                    </select>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                    <div className="box-in">
                                        <div className="box-tocart">
                                            {prices && (
                                                <div id="installation_service">
                                                    {prices.map(
                                                        (price, index) => {
                                                            if (price.installation_price && this.state.compatibility === price.edition) {
                                                                return (
                                                                    <div>
                                                                        <div className="case-checkbox" >
                                                                            <input className="box-opacity" type="checkbox" onChange={this.updateInstallation} name="installation_service"/>
                                                                            <label className="bg-arrow" htmlFor="installation_service"/>
                                                                        </div>
                                                                        <span key={index}>
                                                                            <span>Installation Service </span>
                                                                            <span className="price currency">{price.installation_price}</span>
                                                                        </span>
                                                                    </div>
                                                                );
                                                            }
                                                        }
                                                    )}
                                                </div>
                                            )}

                                        </div>
                                    </div>

                                    <hr className="price-divider" />

                                    <div className="product-info-price">
                                        <div className="price-final_price" data-role="priceBox">
                                            <div>
                                                {pricing_model.pricing_type === PRICING_TYPE.SUBSCRIPTION && prices ?
                                                    <div className="price-box">
                                                        <div>First Year: </div>
                                                        <div className="right">
                                                            {prices.map(
                                                                (priceitem1, index) => {
                                                                    if (this.state.compatibility === priceitem1.edition) {
                                                                        return (
                                                                            <span className="price currency" key={index}>
                                                                            {priceitem1.initial_price}
                                                                            </span>
                                                                        );
                                                                    }
                                                                }
                                                            )}
                                                        </div>
                                                    </div>
                                                    :
                                                    <div className="price-box">
                                                        <div>Product: </div>
                                                        <div className="right">
                                                            {prices.map(
                                                                (priceitem1, index) => {
                                                                    if (this.state.compatibility === priceitem1.edition) {
                                                                        return (
                                                                            <span className="price currency" key={index}>
                                                                            {priceitem1.price}
                                                                            </span>
                                                                        );
                                                                    }
                                                                }
                                                            )}
                                                        </div>
                                                    </div>
                                                }
                                                {pricing_model.pricing_type === PRICING_TYPE.SUBSCRIPTION && prices ?
                                                    <div className="price-box">
                                                        <div>Then: </div>
                                                        <div className="right">
                                                            {prices.map(
                                                                (priceitem1, index) => {
                                                                    if (this.state.compatibility === priceitem1.edition) {
                                                                        return (
                                                                            <span className="price currency" key={index}>
                                                                            {priceitem1.price} &nbsp;/ year
                                                                            </span>
                                                                        );
                                                                    }
                                                                }
                                                            )}
                                                        </div>
                                                    </div>
                                                    :
                                                    null
                                                }
                                                {prices.map(
                                                    (priceitem1, index) => {
                                                        if (priceitem1.installation_price && this.state.compatibility === priceitem1.edition) {
                                                            return (
                                                                <div className="price-box">
                                                                    <div>Installation: </div>
                                                                    <div className="right">                                                                        
                                                                        <span className="price currency" key={index}>
                                                                        {this.state.addInstallService ? priceitem1.installation_price : 0}
                                                                        </span>
                                                                    </div>
                                                                </div>
                                                            );
                                                        }
                                                    }
                                                )}
                                                { this.state.addSupportService && (
                                                    <div className="price-box">
                                                        <div>Support: </div>
                                                        <div className="right">
                                                            <span className="price currency" >
                                                                {this.state.supportServicePrice}
                                                            </span>
                                                        </div>
                                                    </div>
                                                )}
                                                <div className="price-box mt-4">
                                                    <div>
                                                        {pricing_model.pricing_type === PRICING_TYPE.SUBSCRIPTION && prices ?<strong>Total Due Today: </strong>:<strong>Total: </strong>}
                                                    </div>
                                                    {prices && (
                                                        <div className="right final">
                                                            {prices.map(
                                                                (priceitem, index) => {
                                                                    if (this.state.compatibility === priceitem.edition && this.state.addInstallService) {
                                                                        return (
                                                                            <span className="price currency" key={index}>
                                                                                {priceitem.installation_price + this.state.supportServicePrice + (pricing_model.pricing_type === PRICING_TYPE.SUBSCRIPTION && prices ? priceitem.initial_price : priceitem.price)}
                                                                            </span>
                                                                        );
                                                                    }
                                                                    else if (this.state.compatibility === priceitem.edition) {
                                                                        return (
                                                                            <span className="price currency" key={index}>
                                                                                {this.state.supportServicePrice +  (pricing_model.pricing_type === PRICING_TYPE.SUBSCRIPTION && prices ? priceitem.initial_price : priceitem.price)}
                                                                            </span>
                                                                        );
                                                                    }
                                                                }
                                                            )}
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="box-in">
                                        <div className="box-tocart add-to-cart">
                                            <div className="add-to-cart">
                                                <Button UNSAFE_style={{borderRadius: "25px"}} height="40px" width="100%" className="spectrum-Button spectrum-Button--fill spectrum-Button--accent spectrum-Button--sizeL" variant="cta">
                                                    <a className="font-16-override">Add to Cart</a>
                                                </Button>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="box-in">
                                        {user_profile && (
                                            <div>
                                                <Button UNSAFE_style={{borderRadius: "25px", borderColor: "#d5d5d5"}} onClick={()=> window.open(user_profile.is_company && user_profile.company_profile.support_email ? "mailto:" + user_profile.company_profile.support_email : "mailto:" + user_profile.email, "_blank")} height="40px" width="100%" className="spectrum-Button spectrum-Button--outline spectrum-Button--secondary spectrum-Button--sizeL" variant="secondary">
                                                    Contact Vendor
                                                </Button>
                                            </div>
                                        )}
                                    </div>
                                </div>

                            </div>
                        </div>
                        <div style={{display: "flex"}}>
                            <div className="content-section">
                                <ul className="spectrum-SideNav no-bullet-list">
                                    <li className="spectrum-SideNav-item is-selected">
                                        <div className="preview-contents">CONTENTS</div>
                                        <a className={getTabClass("overview")}data-tab="tab-1" href="#product.info.description"
                                           id="overview" onClick={this.activateTab}>Overview
                                        </a>
                                    </li>
                                    <li>
                                        <a className={getTabClass("techspec")} data-tab="tab-2" href="#product.info.techspec" id="techspec"
                                           onClick={this.activateTab}>Technical Specification
                                        </a>
                                    </li>
                                    <li>
                                        <a className={getTabClass("releaseNotes")} data-tab="tab-3" href="#product.info.details.release_notes"
                                           id="releaseNotes" onClick={this.activateTab}>Release Notes
                                        </a>
                                    </li>
                                    <li>
                                        <a className={getTabClass("support")} data-tab="tab-4" href="#product.info.support"
                                           id="support" onClick={this.activateTab}>Support
                                        </a>
                                    </li>
                                </ul>
                            </div>

                            <div className="row preview-details-section">
                                <div className="product-data-items tab-content active" id="tab-1">
                                    <div className="row box-head" id="product.info.description">
                                        <h3>Overview</h3>
                                            <a className="box-back-top" href="#top">
                                                Back to top
                                            </a>
                                    </div>
                                    <hr />
                                    <div className="box">
                                        <div className="product attribute description">
                                            {long_description && (
                                                <div id="long_description" dangerouslySetInnerHTML={{__html: stripXss(long_description).toString()}}/>
                                            )}
                                        </div>
                                    </div>

                                    <div className="product-data-items tab-content active" id="tab-2">
                                        <div className="row box-head" id="product.info.techspec">
                                            <h3>Technical Specification</h3>
                                            <a className="box-back-top" href="#top">
                                                Back to top
                                            </a>
                                        </div>
                                        <hr />
                                        <div className="box">
                                            <div className="product attribute tech-spec">
                                                <div className="column-33">
                                                    <div className="label">Seller Profile</div>
                                                    {user_profile && (
                                                        <div className="">
                                                            <a href={user_profile.sellers_profile_url} target="_blank">
                                                                {user_profile.is_company && user_profile.company_profile.name ? user_profile.company_profile.name : user_profile.first_name + " " + user_profile.last_name}
                                                            </a>
                                                        </div>
                                                    )}
                                                    <div className="label">Seller Contact</div>
                                                    {user_profile && (
                                                        <div className="">
                                                            <a href={user_profile.is_company && user_profile.company_profile.support_email ? "mailto:" + user_profile.company_profile.support_email : "mailto:" + user_profile.email}> E-mail </a>
                                                        </div>
                                                    )}
                                                    {external_services.is_saas &&(
                                                        <div className="clearfix ">
                                                            <div className="label">
                                                                Integrator:
                                                            </div>
                                                            {external_services.items[0].name &&(
                                                                <div>
                                                                    <a href={this.inspectUrl(external_services.items[0].url)} target="_blank">
                                                                        {external_services.items[0].name}
                                                                    </a>
                                                                </div>
                                                            )}
                                                        </div>
                                                    )}
                                                    <div className="label">Current Version</div>
                                                    {version && (
                                                        <div className=""> {version} </div>
                                                    )}
                                                    <div className="label">Adobe Commerce platform compatibility</div>
                                                    {version_compatibility && (
                                                        <div>
                                                            {version_compatibility.map(
                                                                (compatibility, index) => {
                                                                    return (
                                                                        <div key={index} >
                                                                            <span className="pr-2">{formatCompatibilityName(compatibility.edition)}</span>
                                                                            {compatibility.versions.reverse().map(
                                                                                (versions, index) => {
                                                                                    return (
                                                                                        <span key={index}>{versions + (index >= 0 && index !== compatibility.versions.length - 1 ? ', ' : '')} </span>
                                                                                    );
                                                                                }
                                                                            )}
                                                                        </div>
                                                                    );
                                                                }
                                                            )}
                                                        </div>
                                                    )}
                                                    {technical_options && is_page_builder && (
                                                        <div>
                                                            <div className="label" id="page_builder"> Page Builder Compatibility</div>
                                                            <div>
                                                                {technical_options && technical_options.page_builder_new_content_type &&(
                                                                    <div>{PAGEBUILDER_OPTIONS.page_builder_new_content_type}</div>
                                                                )}

                                                                {technical_options && technical_options.page_builder_extends_content_type && (
                                                                    <div>{PAGEBUILDER_OPTIONS.page_builder_extends_content_type}</div>
                                                                )}
                                                                {technical_options && technical_options.page_builder_used_for_content_creation && (
                                                                    <div>{PAGEBUILDER_OPTIONS.page_builder_used_for_content_creation}</div>
                                                                )}
                                                            </div>
                                                        </div>
                                                    )}
                                                </div>

                                                <div className="column-33">
                                                    <div className="label">Type</div>
                                                    {stability && (
                                                        <div className="text-capitalize">
                                                            {stability} build
                                                        </div>
                                                    )}
                                                    <div className="label">Updated</div>
                                                    {modified_at && (
                                                        <div className="">
                                                            {new Date(this.props.previewProduct.modified_at.replace(/-/g, '/')).toLocaleDateString([], {
                                                                day: "numeric",
                                                                month: "long",
                                                                year: "numeric"
                                                            })}
                                                        </div>
                                                    )}

                                                    <div className="label">Categories</div>
                                                    {categories && (
                                                        <div className="">
                                                            {this.getFormattedCategories(categories).map(item => {
                                                                return <div> {item} </div>
                                                            })}
                                                        </div>
                                                    )}
                                                    <div className="label">Supported Browsers</div>
                                                    {browsers && (
                                                        <div className="">
                                                            {browsers.map(item => {
                                                                return <div className="text-capitalize"> {item} </div>
                                                            })}
                                                        </div>
                                                    )}
                                                </div>
                                                <div className="column-33">
                                                    <div className="label">Documentation</div>
                                                    {documentation_artifacts && (
                                                        <div className="">
                                                            {documentation_artifacts.user.url && (
                                                                <div> <a href={documentation_artifacts.user.url}>User Guide</a> </div>
                                                            )}
                                                            {documentation_artifacts.installation.url && (
                                                                <div> <a href={documentation_artifacts.installation.url}>Installation Guide</a> </div>
                                                            )}
                                                            {documentation_artifacts.reference.url && (
                                                                <div> <a href={documentation_artifacts.reference.url}>Reference Manual</a> </div>
                                                            )}
                                                        </div>
                                                    )}

                                                    <div className="label">License Type</div>
                                                    {license_type && license_type === LICENSE_TYPE_VALUE.CUSTOM ? (
                                                        <div className="">
                                                            <a href={this.inspectUrl(custom_license_url)}>{custom_license_name}</a>
                                                        </div>
                                                    ) : (
                                                        <div className="">
                                                            {this.getLicenseFullName(license_type)}
                                                        </div>
                                                    )}

                                                    <div className="label">Policy</div>
                                                    {user_profile.privacy_policy_url && (
                                                        <div className="">
                                                            <a href={this.inspectUrl(user_profile.privacy_policy_url)} target="_blank">
                                                                Privacy Policy
                                                            </a>
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                        <div className="product-data-items tab-content active" id="tab-3">
                                            <div className="row box-head" id="product.info.details.release_notes">
                                                <h3>Release Notes</h3>
                                                <a className="box-back-top" href="#top">
                                                    Back to top
                                                </a>
                                            </div>
                                            <hr/>
                                            {version && (
                                                    <h4> {version}: </h4>
                                            )}
                                            {version_compatibility && (
                                                <ul style={{listStyleType: "none"}}>
                                                    {version_compatibility.map(
                                                        (compatibility, index) => {
                                                            return (
                                                                <li key={index} >
                                                                    <strong style={{fontSize: 'medium'}}> Compatible with {formatCompatibilityName(compatibility.edition)} : </strong> 
                                                                    {compatibility.versions.reverse().map(
                                                                        (versions, index) => {
                                                                            return (
                                                                                
                                                                                <span key={index}>{versions} </span>
                                                                            );
                                                                        }
                                                                    )}
                                                                </li>
                                                            );
                                                        }
                                                    )}
                                                    <li>
                                                        <strong>Description: </strong>
                                                        {release_notes && (
                                                            <div id="release_notes" dangerouslySetInnerHTML={{__html: stripXss(release_notes).toString()}}/>
                                                        )}
                                                    </li>
                                                </ul>
                                            )}
                                        </div>

                                        <div className="product-data-items tab-content active" id="tab-4">
                                            <div className="row box-head" id="product.info.support">
                                                <h3>Support</h3>
                                                <a className="box-back-top" href="#top">
                                                    Back to top
                                                </a>
                                            </div>
                                            <hr />
                                            <div className="box">
                                                <div id="support tab-content">
                                                    <p>The best place to start if you need help with a specific extension is to contact the developer. All Magento developers have both a contact email and a support email listed.</p>
                                                    {user_profile && (
                                                        <div className="">
                                                            <a href={user_profile.is_company && user_profile.company_profile.support_email ? "mailto:" + user_profile.company_profile.support_email : "mailto:" + user_profile.email}> Contact Vendor </a>
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                );
            } else {
                return (
                    <div className="col-sm-12 pt-4 vh-100">
                        <h3>Preview Unavailable</h3>
                    </div>
                );
            }
        };

        return (
            <Fragment>
                {!this.state.loading ? (_showPreview()) : (<div> <FaSpinner className="fa-pulse ml-2" /></div>)}
            </Fragment>
        );
    }
}

PreviewPage.propTypes = {
    previewProduct: PropTypes.object,
    match: PropTypes.object.isRequired
};

const mapStateToProps = state => {
    return {
        previewProduct: state.products.selectedProduct
    };
};

const mapDispatchToProps = dispatch => {
    return {
        getUserProductPreview: id => {
            dispatch(getUserProductPreview(id));
        },
        getUserProductPreviewForAdmin: id => {
            dispatch(getUserProductPreviewForAdmin(id));
        }
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(PreviewPage);
